import React from "react";
import { Form } from "antd";
import { Grid, TextField, Snackbar } from "@material-ui/core";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

import MySnackbarContentWrapper from "../../../components/SnackBar";
import Sizes from "./sizes";
import Autocomplete from "@material-ui/lab/Autocomplete";

class AdUnitForm extends React.Component {
  state = {
    confirmDirty: false,
    autoCompleteResult: [],
    snackOpen: false,
    snackType: "info",
    snackMessage: "Action executing...",
    adUnitsSizes: this.props.sizes ? this.props.sizes : [],
    publisherIds: [],
  };

  handleClose = () => {
    this.setState({ snackOpen: false });
  };

  handlePlus = () => {
    this.setState({
      adUnitsSizes: [...this.state.adUnitsSizes, { size: [0, 0] }],
    });
  };

  setStateValues = (open, type, message) => {
    this.setState({ snackOpen: open });
    this.setState({ snackType: type });
    this.setState({ snackMessage: message });
  };

  generateSizes = (column1, column2) => {
    const sizes = [];
    column1.map(first => {
      sizes.push({ size: [parseFloat(first)] });
    });
    column2.map((second, index) => {
      sizes[index].size.push(parseFloat(second));
    });

    return sizes;
  };

  handleSubmit = e => {
    e.preventDefault();
    this.setState({ snackOpen: true });
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        const id = this.props.id ? this.props.id : "";
        const input = {
          publisherId: values.publisherId,
          sizes: this.generateSizes(values.column1, values.column2),
          tag: values.tag,
          slot: values.slot,
        };
        this.props
          .query_f({
            variables: {
              id,
              input,
            },
          })
          .then(
            result => {
              this.setStateValues(
                true,
                "success",
                "Action executed with success!",
              );
              this.props.form.resetFields();
              if (this.props.onCancel) {
                this.props.onCancel();
              }
              localStorage.setItem("adireto-drawer-open", false);
            },
            error => {
              this.setStateValues(true, "error", "Action executed with error!");
            },
          );
      } else {
        this.setStateValues(true, "error", "Form validation failed!");
      }
    });
  };

  handleConfirmBlur = e => {
    const value = e.target.value;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  };

  handleSelectChange = e => {
    this.props.form.setFieldsValue({
      tag: e.target.value,
    });
  };

  findPublisherId(publisherIds, domain) {
    const found = publisherIds.find(element => element.domain === domain);
    return found.publisherId;
  }

  findPublisherById(publisherIds, publisherId) {
    const found = publisherIds.find(
      element => element.publisherId === publisherId,
    );
    return found;
  }

  handleSelectChangePublisherId = (domain, publisherIds) => {
    const publisherId = this.findPublisherId(publisherIds, domain);
    this.props.form.setFieldsValue({
      publisherId: publisherId,
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const publisher = this.findPublisherById(
      this.props.publisherIds,
      this.props.publisherId,
    );
    return (
      <form id="myForm" onSubmit={this.handleSubmit}>
        <Snackbar
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          open={this.state.snackOpen}
          autoHideDuration={6000}
          onClose={this.handleClose}
        >
          <MySnackbarContentWrapper
            onClose={this.handleClose}
            variant={this.state.snackType}
            message={this.state.snackMessage}
          />
        </Snackbar>
        <Grid container spacing={0}>
          <Grid item xs={12}>
            {this.props.form.getFieldDecorator("publisherId")}
            <Autocomplete
              fullWidth
              options={this.props.publisherIds}
              getOptionLabel={option => option.domain}
              defaultValue={
                publisher !== undefined
                  ? publisher
                  : { domain: "", publisherId: "" }
              }
              renderInput={params => (
                <TextField {...params} label="publisher" variant="outlined" />
              )}
              onInputChange={(e, value) =>
                this.handleSelectChangePublisherId(
                  value,
                  this.props.publisherIds,
                )
              }
            />
          </Grid>

          <Grid item xs={12}>
            {getFieldDecorator("slot", {
              initialValue: this.props.slot || "",
              rules: [
                {
                  required: true,
                  message: "Please input your slot!",
                  whitespace: true,
                },
              ],
            })(
              <TextField
                id="slot"
                label="slot"
                color="primary"
                fullWidth
                style={{ marginTop: 13 }}
                InputLabelProps={{
                  shrink: true,
                }}
                placeholder="slot"
              />,
            )}
          </Grid>

          <Grid item xs={12}>
            <Sizes
              sizes={
                this.props.sizes ? this.props.sizes : [{ size: ["0", "0"] }]
              }
              form={this.props.form}
            />
          </Grid>

          <Grid item xs={12}>
            {getFieldDecorator("tag", {
              initialValue: this.props.tag || "",
              rules: [
                {
                  required: true,
                  message: "Please input your tag!",
                  whitespace: true,
                },
              ],
            })(
              <>
                <InputLabel style={{ marginTop: 13, fontSize: 12 }}>
                  Tag
                </InputLabel>
                <Select
                  id="tag"
                  label="tag"
                  placeholder="tag"
                  fullWidth
                  defaultValue={this.props.tag || ""}
                  onChange={this.handleSelectChange}
                >
                  <MenuItem value={"ANCHOR"}>ANCHOR</MenuItem>
                  <MenuItem value={"IMG"}>IMG</MenuItem>
                  <MenuItem value={"SKYSCRAPER"}>SKYSCRAPER</MenuItem>
                  <MenuItem value={"P"}>P</MenuItem>
                  <MenuItem value={"UL"}>UL</MenuItem>
                  <MenuItem value={"ARTICLE"}>ARTICLE</MenuItem>
                  <MenuItem value={"HEADER"}>HEADER</MenuItem>
                  <MenuItem value={"FOOTER"}>FOOTER</MenuItem>
                  <MenuItem value={"NAV"}>NAV</MenuItem>
                  <MenuItem value={"ANCHOR_SIDEBAR"}>ANCHOR_SIDEBAR</MenuItem>
                  <MenuItem value={"VALIDATION"}>VALIDATION</MenuItem>
                  <MenuItem value={"VIDEO"}>VIDEO</MenuItem>
                </Select>
              </>,
            )}
          </Grid>
        </Grid>
      </form>
    );
  }
}

const AdUnitsForm = Form.create()(AdUnitForm);

export default AdUnitsForm;
